import AiIcon from '@interxfi/design-system/icons/react/icon-ai';
import AlertIcon from '@interxfi/design-system/icons/react/icon-alert';
import AvatarIcon from '@interxfi/design-system/icons/react/icon-avatar';
import BillIcon from '@interxfi/design-system/icons/react/icon-bill';
import InventoryIcon from '@interxfi/design-system/icons/react/icon-inventory';
import InvestingIcon from '@interxfi/design-system/icons/react/icon-investing';
import LedgerIcon from '@interxfi/design-system/icons/react/icon-ledger';
import SafeIcon from '@interxfi/design-system/icons/react/icon-safe';
import { IxcRegistrationV1Purpose } from '@interxfi/types/generated/api';
import { exhaustiveCheck } from '@interxfi/utilities/types/exhaustive';

interface AccountPurposeIconProps {
  purpose: IxcRegistrationV1Purpose;
}

export function AccountPurposeIcon({ purpose }: AccountPurposeIconProps) {
  switch (purpose) {
    case IxcRegistrationV1Purpose.Inventory:
      return <InventoryIcon aria-hidden />;
    case IxcRegistrationV1Purpose.TradeError:
      return <AlertIcon aria-hidden />;
    case IxcRegistrationV1Purpose.Customer:
      return <AvatarIcon aria-hidden />;
    case IxcRegistrationV1Purpose.Billing:
      return <BillIcon aria-hidden />;
    case IxcRegistrationV1Purpose.Deposit:
      return <SafeIcon aria-hidden />;
    case IxcRegistrationV1Purpose.Settlement:
      return <LedgerIcon aria-hidden />;
    case IxcRegistrationV1Purpose.AveragePrice:
      return <InvestingIcon aria-hidden />;
    case IxcRegistrationV1Purpose.Special:
      return <AiIcon aria-hidden />;
    case IxcRegistrationV1Purpose.Unspecified:
      return <AlertIcon aria-hidden />;
    default: {
      exhaustiveCheck(purpose);
      return null;
    }
  }
}
